import React from 'react'
import { StaticQuery, graphql } from 'gatsby'
import styled from '@emotion/styled'
import PageBase from '@/components/common/Page'
import ThemeConsumer from '@/hoc/ThemeConsumer'
import SEO from '@/components/head/seo'
import LD from '@/components/head/linking-data'
import LDEntity from '@/utils/linking-data'
import { layouts } from '@/utils/preset'
import Breadcrumb from '@/components/app/Breadcrumb.container'
import PageHead from '@/components/app/PageHead'
import AboutOverview from '@/components/modules/About/Overview'
import AboutIntegration from '@/components/modules/About/Integration'
import AboutCompare from '@/components/modules/About/Compare'
import FeatureLead from '@/components/modules/Feature/Lead'
import PricingLead from '@/components/modules/Pricing/Lead'
import ConversionLead from '@/components/modules/Conversion/Lead'

const AboutIndexPage = props => (
  <StaticQuery
    query={query}
    render={data => {
      const siteMeta = data.site.siteMetadata
      const title = 'FVPとは'
      const description = 'FVP（フロントビジョンプランナー）は、企業経営・業務分析の専門家である「中小企業診断士」が国内2,300社の業務分析結果にもとづき、設計された中小企業向けのクラウド型ERPです。'
      return (
        <Root>
          <SEO location={props.location} title={title} description={description}/>
          <LD json={{
            '@type': 'WebPage',
            '@id': `${siteMeta.siteUrl}/about/#webpage`,
            name: `${title} | ${siteMeta.title}`,
            description: description,
            url: `${siteMeta.siteUrl}/about/`,
            inLanguage: 'ja',
            datePublished: '2019-11-10T10:00:00+09:00',
            dateModified: '2019-11-10T10:00:00+09:00',
            isPartOf: LDEntity.WebSite(siteMeta)
          }}/>
          <Breadcrumb path={props.location.pathname} />
          <Head>
            <PageHead
              title={title}
              description={description}
            />
          </Head>
          <Main>
            <AboutOverview />
            <Border theme={props.theme} />
            <AboutIntegration />
            <Border theme={props.theme} />
            <AboutCompare />
            <Border theme={props.theme} />
            <FeatureLead />
            <Border theme={props.theme} />
            <PricingLead />
            <Border theme={props.theme} />
            <ConversionLead />
          </Main>
        </Root>
      )
    }}
  />
)

const Root = styled.div`
`

const Head = styled.div``

const Main = styled.div``

const Border = styled(layouts.components.FullWidth)`
  height: 1px;
  background-color: ${props => props.theme.line.base};
`

export default PageBase(ThemeConsumer(AboutIndexPage))

const query = graphql`
  query AboutIndexPageQuery {
    site {
      siteMetadata {
        siteUrl
        title
        description
        keywords
        image
        company {
          name
          logo
          siteUrl
        }
      }
    }
  }
`
